import React from 'react';
import { card } from '../@types/AppConfiguration';
import './Card.scss';
import MapLegend from '../Map/Legend/Legend';

const Card: React.FC<card> = ({
  title,
  description,
  legends,
  selectedLegendTypes,
  onUpdate,
}) => {
  return (
    <div className="world-map-leadspace-widget__card">
      <div className="world-map-leadspace-widget__card--top-segment">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="world-map-leadspace-widget__card--bottom-segment">
        <MapLegend
          legends={legends}
          selectedLegendTypes={selectedLegendTypes}
          onUpdate={onUpdate}
        />
      </div>
    </div>
  );
};

export default Card;
